import { ReactNode } from 'react';
import { useLogger } from '@packages/shared/core/common/hooks';
import { useQuizStep } from '@packages/shared/core/quiz/hooks';
import { Coordinates } from '@packages/shared/core/common/entities';
import { PlaceStepData, QuizScreenProps } from '@packages/shared/core/quiz/entities';

type PlaceQuizStepProps = {
  id: string;
  renderQuizScreen: (stepData: QuizScreenProps) => ReactNode;
};

const PlaceQuizStep = ({ id, renderQuizScreen }: PlaceQuizStepProps) => {
  const logger = useLogger();
  const { back, next, stepData, updateUserPreferences, userPreferences } = useQuizStep(id);

  if (!stepData) {
    // TODO add fallback
    logger.error(new TypeError(`Data for ${id} step not found`));
    return null;
  }

  const { placeDataKey, locationDataKey } = stepData as PlaceStepData;

  const initialLocation =
    typeof userPreferences[locationDataKey] === 'string' ? (userPreferences[locationDataKey] as string) : '';
  const initialCoordinates: Coordinates = Array.isArray(userPreferences[placeDataKey])
    ? (userPreferences[placeDataKey] as Coordinates)
    : ['', ''];

  const goBack = async () => back();

  const onPlaceChosen = async (coordinates: Coordinates, location: string) => {
    updateUserPreferences(locationDataKey, location);
    updateUserPreferences(placeDataKey, coordinates);
    await next();
  };

  return (
    <>
      {renderQuizScreen({
        onBack: goBack,
        initialLocation,
        initialCoordinates,
        onChosen: onPlaceChosen,
        ...(stepData as PlaceStepData),
      })}
    </>
  );
};

export default PlaceQuizStep;
